import { render, staticRenderFns } from "./SurveyPackageDetail.vue?vue&type=template&id=74907955&scoped=true&"
import script from "./SurveyPackageDetail.vue?vue&type=script&lang=js&"
export * from "./SurveyPackageDetail.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPackageDetail.vue?vue&type=style&index=0&id=74907955&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74907955",
  null
  
)

export default component.exports